import { createWithEqualityFn } from 'zustand/traditional';


type CalendarNavigationState = {
    index: number,
    reset: () => any
    next: () => any
    previous: () => any
    up: () => any
    down: () => any
    is: (idx: number) => boolean
    set: (idx: number) => void
}

const useCalendarNavigation = createWithEqualityFn<CalendarNavigationState>(
    (set, get) => ({
        index: -1,
        reset: () => set({index: -1}),
        set: (index: number) => set({index: index}),
        next: () => {
            if (get().index < 34)
                set({index: get().index + 1})
        },
        previous: () => {
            if (get().index > 0)
                set({index: get().index - 1})
        },
        up: () => {
            if (get().index > 6)
                set({index: get().index - 7})
        },
        down: () => {
            if (get().index < 28)
                set({index: get().index + 7})

        },
        is: (idx: number) => get().index === idx
    })
);

export default useCalendarNavigation;
